import React from 'react';
import { Redirect } from 'react-router-dom';
import logo from './images/Allosense_Logo_Black.png';

class Home extends React.Component {
  state = {
    bucketUrl: null 
  }

  handleSubmit = e => {
    e.preventDefault()
    this.setState({ bucketUrl: this.input.value })
  }

  render(){
    // Add AWS Cognito Plugin below.
    // 
    //
    // Execution Plans:
    // (1) Functionality First, (2) Design, (3) Optimizations / Scalability
    //
    // Primary Objectives:
    // 1A. Add Wireframe for Registration
    // 1B. Find a Tutorial on Implementing Cognito in React Native
    // 2. Create Backend Solution: Cognito -> Amazon RDS -> AuroraDB
    // 3. Create Front End:
    //            - Registration Page for interacting with Cognito
    //            - Create Sign-In Page
    //
    // Requirements:
    // 1. Access to GitLabs (Complete): git-allosense-cloud-gui
    // 2. Test out VSCode (Roman to give tutorial)
    // 3. Setup AWS CLI
    // 4. Execute git-allosense-cloud-gui/aws-upload.sh:
    //            $ cd git-allosense-cloud-gui
    //            $ ./aws-upload.sh
    //
    // Secondary Objective: Use Pulumi


    if ( this.state.bucketUrl ) return <Redirect to={this.state.bucketUrl} /> 
    return (
      <div className="home">
        <img alt="Logo for Allosense" src={logo} height='150'/>
        <p>Please Sign In:</p>
        <form onSubmit={this.handleSubmit}>
          <p><input ref="null" type="text" placeholder="Account ID" defaultValue="TestCompany"></input></p>
          <p><input ref={ref => this.input = ref} type="password" placeholder="Password" defaultValue="at4-atb140c0810d5e"></input></p>
          &nbsp;&nbsp;
          <input type="submit" value="Submit" />
        </form>
      </div>
    )
  }
}

export default Home
